<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
        <e-item v-if='exportBoolean' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.export")' :click='notices' eventType='export'></e-item>
        <e-item v-if='statisticsBoolean' prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText='$t("Alarm.statistics")' :click='notices' eventType='statistics'></e-item>
        <e-item v-if='filterBoolean' prefixIcon='icon hero-icon hero-icon-advanced-search-detailed' :tooltipText='$t("Alarm.advancedSearch")' :click='notices' eventType='filter'></e-item>
        <e-item :prefixIcon='subscritionIcon' :tooltipText='$t("Alarm.eventSubscription")' :click='subscritionFunc'></e-item>
      </e-items>
    </ejs-toolbar>
    <div class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Alarm.pleaseEnterAlmId")' :width="320" @input='updateKeywords' @keydown.native='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>
<script>
export default {
  name: 'eventLogButton',
  data() {
    return {
      statisticsBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_event.Statistics,
      exportBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_event.Export,
      filterBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_event.AdvancedSearch,
      isOn: '0',
      queryConditions: {
        systemId: '1',
        keywords: ''
      }
    };
  },
  computed: {
    subscritionIcon() {
      return this.isOn === '1' ? 'icon hero-icon hero-icon-on' : 'icon hero-icon hero-icon-off hero-icon-off-active';
   }
  },
  methods: {
    notices(args) {
      if (args.item.eventType === 'refresh') {
        this.queryConditions.keywords = '';
      }
      this.$emit('notice', args.item.eventType);
    },
    getSubscritionStatus() {
      // 刷新事件订阅状态 0:off 1:on
      const This = this;
      this.$axios.post('/lte/ems/fm/event/queryIsOn').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = `${response.data.resultVal.isOn}`;
          this.$emit('isOn', this.isOn);
        }
      });
    },
    subscritionFunc() {
      // 点击事件订阅
      this.$axios.post('/lte/ems/fm/event/modifyAutoPara').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          this.isOn = this.isOn === '1' ? '0' : '1';
          this.$emit('isOn', this.isOn);
          this.$emit('notice', 'refresh');
        }
      });
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        if (this.queryConditions.keywords === '') {
          this.queryConditions.keywords = '';
          this.$emit('notice', 'conditions');
        } else {
          this.$emit('notice', 'keywords');
        }
      }
    }
  }
};
</script>
